import {
  dealDirectionValues,
  dealTypeValues,
} from '@standandforce/api-contract';
import { z } from 'zod';

import { dataGridSearchFields } from '@/features/dynamic-table';

export const DealTableFilterSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  direction: z.enum(dealDirectionValues).optional(),
  dealType: z.enum(dealTypeValues).optional(),
});

export type DealTableFilterSchema = z.infer<typeof DealTableFilterSchema>;
